@use '../../../../styles/Constants.scss' as Constants;
@use '../../../../styles/Colors.scss' as Colors;

.container {
	border-radius: Constants.$val-borderRadius;
	background: var(--col-white-0);
	border: 1px solid Colors.$col-greyMid;

	& :global(.dropdown-toggle) {
		padding: 0;
		min-width: 0;
	}
}

.placeholder {
	padding: 0 Constants.$val-spacing-s 0 Constants.$val-spacing-m;
	display: flex;
	height: 100%;
	justify-content: center;
	align-items: center;
	color: var(--col-grey-700);
}

.icon {
	margin-left: Constants.$val-spacing-xs;
	margin-right: Constants.$val-spacing-xs !important;
}

.option {
	white-space: nowrap;
}